/**
 * Page is only accessible if user is a guest.
 */

import AuthRedirectUtil from '@utils/AuthRedirectUtil';

export default function({ to, from, store }) {
    // Store referral.
    if (to.query.ref && to.query.ref.trim() !== '') {
        store.commit('setRef', to.query.ref);
    }
    if (store.getters.apiKey) {
        const redirect = AuthRedirectUtil.safePath(to.query.redirect);
        if (redirect) {
            return { path: redirect };
        } else if (to.name === 'ltd') {
            return { name: 'account.ltd' };
        } else {
            return { name: 'dashboard' };
        }
    }
}
